module.exports = __webpack_public_path__ + "img/logo_plant-my-tree.d3817f5.svg";